import { ArticleView } from "@serophin/nottldr-shared";
import { useArticleList } from "@serophin/nottldr-shared/hooks";
import { HeaderTab } from "../../components/explore/HeaderTab";
import { ArticleList } from "../../components/feed/ArticleList";
import { useHeaderActions } from "../../hooks/useHeaderActions";
import type { PageProps } from "../pageProps";
import { useRequireSession } from "./useRequireSession";

const FEED_EMPTY = "Your feed will show articles from authors you follow. Start following some authors to see their content here!";
const RECOMMENDED_EMPTY =
  "We're working on finding great articles for you. Check back soon or explore our collection to discover interesting articles and authors!";

type Tab = "feed" | "recommended";

const useHomeTabs = (activeTab: Tab): void => {
  useHeaderActions(
    () => (
      <div class="flex items-end h-full">
        <HeaderTab href="/" isActive={activeTab === "feed"}>
          Feed
        </HeaderTab>
        <HeaderTab href="/recommended" isActive={activeTab === "recommended"}>
          For you
        </HeaderTab>
      </div>
    ),
    [activeTab],
  );
};

const HomeList = ({ tab }: { tab: Tab }) => {
  const list = useArticleList(tab === "feed" ? ArticleView.FEED : ArticleView.RECOMMENDED, undefined, tab);
  useHomeTabs(tab);
  return <ArticleList list={list} showReadFilter emptyMessage={tab === "feed" ? FEED_EMPTY : RECOMMENDED_EMPTY} />;
};

/** `/` for a signed-in visitor: the articles of the authors they follow. */
export const FeedPage = (_props: PageProps) => (useRequireSession() ? <HomeList tab="feed" /> : null);

/** `/recommended`: the "For you" tab. */
export const RecommendedPage = (_props: PageProps) => (useRequireSession() ? <HomeList tab="recommended" /> : null);
